import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { ICountrySchemaPartial, ICountrySchema } from '../../type/country';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';



export interface ICountryVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  status?: boolean;
}
 sort: {
  _id?: number;
  primary?: number;
  status?: number;
  iso2?: number;
  updatedTime?: number;
}
 search: {
  _id?: string;
  iso2?: string;
  iso3?: string;
  name?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  
 
}
export const CountryQueryTypeDefinitionKey = 'Country';
export type ICountryVarsPartial = Partial<ICountryVars>
export type ICountryDataPartial = DeepPartial<ICountrySchemaPartial>
export interface ICountryQueryData<TData extends ICountrySchema = ICountrySchema>{
  

    countries: IWithPagination<TData>
}

export function countryQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    countries(
        $filter: CountryQueryFilterParameterInput,
$search: CountryQuerySearchParameterInput,
$sort: CountryQuerySortParameterInput,
$skip: Int,
$limit: Int
        ){
        

    countries(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function useCountryLazyQuery<TData extends ICountrySchema>(
  fragment: string,
  options?: QueryHookOptions<ICountryQueryData<TData>, ICountryVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<ICountryQueryData<TData>, ICountryVarsPartial>(countryQuery(fragment, rootFragment, withPagination), options);
}

export function useCountryQuery<TData extends ICountrySchema>(
  fragment: string,
  options?: QueryHookOptions<ICountryQueryData<TData>, ICountryVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<ICountryQueryData<TData>, ICountryVarsPartial>(countryQuery(fragment, rootFragment, withPagination), options);
}
